import { CheckCircle, Mail, Phone } from 'lucide-react';
import { formatPriceParts } from '../../utils/resultDisplay';
import { EMAIL, PHONE, PHONE_RAW, SITE_NAME } from '../../constants/site';

function money(amount, currency = 'USD') {
  return `${currency} ${Number(amount || 0).toFixed(2)}`;
}

export default function BookingPriceSidebar({
  travelerLabel = '1 Traveler(s) - Adult',
  lineItems = [],
  subtotal = 0,
  taxes = 0,
  total = 0,
  selectedTierName,
  currency = 'USD',
  isFlight = false,
}) {
  const totalParts = formatPriceParts(total, currency);
  const tel = PHONE_RAW.replace(/[^\d+]/g, '') || PHONE.replace(/[^\d+]/g, '');

  return (
    <aside className="booking-sidebar booking-sidebar--stick">
      <div className="booking-sidebar__card booking-sidebar__card--summary">
        <h3>Price summary</h3>
        <p className="booking-sidebar__travelers">{travelerLabel}</p>

        {isFlight && selectedTierName && (
          <p className="booking-sidebar__tier-badge">
            Fare type: <strong>{selectedTierName}</strong>
          </p>
        )}

        <div className="booking-sidebar__lines">
          {lineItems.map((row) => (
            <div
              key={row.key}
              className={`booking-sidebar__row${
                row.highlight ? ' booking-sidebar__row--highlight' : ''
              }`}
            >
              <span>{row.label}</span>
              <strong>{money(row.amount, currency)}</strong>
            </div>
          ))}
        </div>

        <div className="booking-sidebar__row booking-sidebar__row--muted">
          <span>Subtotal</span>
          <span>{money(subtotal, currency)}</span>
        </div>
        <div className="booking-sidebar__row booking-sidebar__row--muted">
          <span>Taxes &amp; fees (est.)</span>
          <span>{money(taxes, currency)}</span>
        </div>

        <div className="booking-sidebar__divider" />
        <div className="booking-sidebar__total">
          <span>Total due today</span>
          <strong>
            {totalParts.currency} {totalParts.formatted}
          </strong>
        </div>
        <p className="booking-sidebar__fine">
          Prices update when you change fare type or add-ons. Final amount confirmed at ticketing.
        </p>
      </div>

      <div className="booking-sidebar__trust">
        <p className="booking-sidebar__trust-title">
          Book with <strong>{SITE_NAME}</strong>
        </p>
        <ul className="booking-sidebar__list">
          <li>
            <CheckCircle size={16} aria-hidden /> Best-available fares from our partners
          </li>
          <li>
            <CheckCircle size={16} aria-hidden /> Dedicated agents for changes &amp; refunds
          </li>
          <li>
            <CheckCircle size={16} aria-hidden /> Secure checkout &amp; data protection
          </li>
        </ul>
      </div>

      <div className="booking-sidebar__contact">
        <h4>Questions before you pay?</h4>
        <a href={`tel:${tel}`} className="booking-sidebar__contact-link">
          <Phone size={16} aria-hidden />
          {PHONE}
        </a>
        <a href={`mailto:${EMAIL}`} className="booking-sidebar__contact-link">
          <Mail size={16} aria-hidden />
          {EMAIL}
        </a>
      </div>
    </aside>
  );
}
